<script lang="ts" setup>
interface Properties {
  stock: number;
  nextShippingDate: string;
}

defineProps<Properties>();
</script>

<template>
  <div data-qa="availability">
    <div v-if="stock > 50" class="text-green-600">
      50+
    </div>
    <div v-else-if="stock < 1" class="text-red-600 w-[9vw] text-sm">
      <p v-if="nextShippingDate">
        {{ $t("article.next_shipping_date") }}: {{ nextShippingDate }}
      </p>
      <p v-else>
        {{ $t("article.next_shipping_date_not_available") }}
      </p>
    </div>
    <div v-else class="text-green-600">
      {{ stock }}
    </div>
  </div>
</template>
